export const EnumIndicadores = [
  {
    id: '1',
    name: 'Cantidad de Rutas',
    shortName: 'Cant. de rutas',
    um: 'N° Rutas'
  },
  {
    id: '2',
    name: 'Unidades pickeadas por hora',
    shortName: 'U. picked. X hora',
    um: 'Unidad/Hora'
  },
  {
    id: '3',
    name: 'Tiempo promedio por ruta',
    shortName: 'T. prom. X ruta (min)',
    um: 'Minutos'
  },
  {
    id: '4',
    name: 'Tiempo promedio por SKU',
    shortName: 'T. prom. X SKU (min)',
    um: 'Minutos'
  },
  {
    id: '5',
    name: 'Tiempo efectivo trabajado',
    shortName: 'T. ef. trabajado (hr)',
    um: 'Horas'
  }
]

export const orderDictionary = {
  Alfabetico: 1,

  Ascendente: 2,

  Descendente: 3
}

export const enumTipoIndicador = {
  Cantidad_de_Rutas: '1',

  Unidades_pickeadas_por_hora: '2',

  Tiempo_promedio_por_ruta: '3',

  Tiempo_promedio_por_SKU: '4',

  Tiempo_efectivo_trabajado: '5'
}
